var map = {
	"./AddToCartSvg": 292,
	"./AddToCartSvg.tsx": 292,
	"./GithubSvg": 495,
	"./GithubSvg.tsx": 495,
	"./Slack2Svg": 363,
	"./Slack2Svg.tsx": 363,
	"./SlackSvg": 521,
	"./SlackSvg.tsx": 521,
	"./TwitterSvg": 528,
	"./TwitterSvg.tsx": 528,
	"./bottle.png": 482,
	"./camiseta1.png": 305,
	"./camiseta2.png": 368,
	"./camiseta3.png": 592,
	"./camiseta4.png": 102,
	"./cap.png": 570,
	"./fleece.png": 20,
	"./fonts/sofiapro-black.woff": 317,
	"./fonts/sofiapro-bold.woff": 558,
	"./fonts/sofiapro-light.woff": 366,
	"./fonts/sofiapro-medium.woff": 122,
	"./fonts/sofiapro-regular.woff": 736,
	"./fonts/sofiapro-semi-bold.woff": 240,
	"./hero1.png": 986,
	"./hero2.png": 237,
	"./hero3.png": 727,
	"./lanyard.png": 893,
	"./logo.png": 949,
	"./mug.png": 711,
	"./profile-pic.png": 508,
	"./sticker.png": 792
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 173;